import { Injectable } from "@angular/core";
import { IObjectObserver } from "./IObjectObserver";
import { ReservationSettingsDataModel, ReservationSettingsDMKey } from "../shared/models";
import { CircularInjectionHelper } from "./circularInjectionHelper";
import { ObjectObserverFactory } from "./objectObserverFactory";
import { ContentType } from "../shared/contentTypes";

@Injectable()
export class ReservationSettingService {

  private _reservationSettingObsServ: IObjectObserver<ReservationSettingsDataModel>;

  constructor(private objObsInjectHelper: CircularInjectionHelper) {
    this._reservationSettingObsServ = ObjectObserverFactory.GetObjectObserverByInjectionHelper<ReservationSettingsDataModel>(ContentType.ReservationSettings, objObsInjectHelper);
  }

  public GetReservatonSetting(): Promise<number[]> {
    const me = this;
    return new Promise<number[]>((resolve, reject) => {
      me._reservationSettingObsServ.GetObject(ReservationSettingsDMKey)
        .then(reservationSetting => {
          if (reservationSetting && reservationSetting.locations && reservationSetting.locations.length > 0) {
            resolve(reservationSetting.locations);
          } else {
            resolve(null);
          }
        })
        .catch(e => {
          me.objObsInjectHelper.coreLogService.error("ReservationSettingService.GetReservatonSetting", "._reservationSettingObsServ.GetObject", e);
          reject();
        });
    });
  }
}
